import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Calendar, Loader2 } from "lucide-react";
import { IcalLearnHow } from "@/components/owner/IcalLearnHow";

interface Step6CalendarProps {
  icalUrl: string;
  onChange: (url: string) => void;
  onConnect: () => Promise<void>;
  loading?: boolean;
  connected?: boolean;
}

export function Step6Calendar({
  icalUrl,
  onChange,
  onConnect,
  loading = false,
  connected = false,
}: Step6CalendarProps) {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Booking calendar</h1>
        <p className="text-muted-foreground text-sm mt-1">
          Connect your calendar so cleanings schedule automatically when bookings change.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg flex items-center gap-2">
            <Calendar className="h-5 w-5" />
            Sync your booking calendar
          </CardTitle>
          <CardDescription>
            Connect your Airbnb or VRBO calendar so cleanings are scheduled automatically when
            bookings change.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <div className="flex items-center justify-between gap-2">
              <Label htmlFor="ical-url">iCal URL</Label>
              <IcalLearnHow className="text-xs" />
            </div>
            <Input
              id="ical-url"
              value={icalUrl}
              onChange={(e) => onChange(e.target.value)}
              placeholder="https://www.airbnb.com/calendar/ical/..."
              inputMode="url"
              disabled={connected}
            />
            <p className="text-xs text-muted-foreground">
              Find your iCal URL in Airbnb → Calendar → Availability settings → Export Calendar
            </p>
          </div>
          {connected ? (
            <p className="text-sm text-green-600 font-medium">Calendar connected and synced.</p>
          ) : (
            <Button type="button" onClick={onConnect} disabled={loading || !icalUrl.trim()}>
              {loading ? (
                <>
                  <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                  Connecting…
                </>
              ) : (
                "Connect Calendar"
              )}
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
